import { useEffect } from 'react'
import { listProductionArea } from './storage'

export default function useInitial() {
    useEffect(() => {
        Promise.all([listProductionArea.load()])
    }, [])
}
